import { useActions } from 'components/mapV2/hooks/useActions';
import { DetailQuery_moment } from 'graphql/query/__generated__/DetailQuery';
import { EFonts } from 'libs/styles/styling';
import { getSmallerImage } from 'libs/utils/imageUtils/imageUtils';
import { isDefined } from 'libs/utils/typesafe/isDefined';
import { useContext } from 'react';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    story: DetailQuery_moment;
}

export const MapV2StoryListViewItem = (props: Props): JSX.Element => {
    const actions = useActions();
    const ctxView = useContext(CtxView);
    const { story } = props;

    const categoryImages = story.categories
        .map(
            (category) =>
                ctxView.map.worldMapSets.find((e) => e.worldMapSetId === category.worldMapSetId)
                    ?.imageUrl
        )
        .filter(isDefined);

    const backgroundSize = story.header?.imageStyleId === 'stretch' ? 'cover' : 'contain';

    return (
        <S_MapV2StoryListViewItem
            className={props.className}
            onClick={() => actions.openStoryDetail(story)}
        >
            <S_StoryImage
                $imageUrl={getSmallerImage(story.header?.imageUrl, 400)}
                $backgroundSize={backgroundSize}
            />
            <S_StoryContent>
                <S_StoryTitle>{story.header?.title}</S_StoryTitle>
            </S_StoryContent>

            {categoryImages.length > 0 && (
                <S_CategoryImages>
                    {categoryImages.map((categoryImage) => (
                        <S_CategoryImage
                            key={categoryImage}
                            $imageUrl={getSmallerImage(categoryImage, 400)}
                        />
                    ))}
                </S_CategoryImages>
            )}
        </S_MapV2StoryListViewItem>
    );
};

const S_MapV2StoryListViewItem = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    overflow: hidden;
    background: #f6f7f5;
    border-radius: 10px;
    padding: 5px;
    position: relative;
    &:hover {
        background: #efefef;
    }
`;

const S_StoryImage = styled.div<{ $imageUrl: string; $backgroundSize: 'cover' | 'contain' }>`
    width: 107px;
    height: 85px;
    border-radius: 10px;
    background-image: url(${(props) => props.$imageUrl});
    background-position: center;
    background-repeat: no-repeat;
    background-size: ${(props) => props.$backgroundSize};
    flex: 0 0 107px;
    background-color: white;
`;

const S_StoryContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 6px 10px 10px 10px;
`;

const S_StoryTitle = styled.div`
    font-size: 15px;
    font-family: ${EFonts.InterSemiBold};
    line-height: 21px;
    margin-bottom: 4px;
    color: #2a2a2d;
    // BEIN Ellipsis
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    // END Ellipsis
`;

const S_CategoryImages = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
    position: absolute;
    right: 10px;
    bottom: 10px;
`;

const S_CategoryImage = styled.div<{ $imageUrl: string }>`
    width: 25px;
    height: 25px;
    background-image: url(${(props) => props.$imageUrl});
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: contain;
`;
